interface GlowingButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary';
  children: React.ReactNode;
  className?: string;
  'aria-label'?: string;
}

export default function GlowingButton({ 
  variant = 'primary', 
  children, 
  className = '',
  'aria-label': ariaLabel,
  ...props 
}: GlowingButtonProps) {
  const baseStyles = "relative px-6 py-3 rounded-md font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-black";
  const variants = {
    primary: "bg-[#FFD700]/10 text-[#FFD700] hover:bg-[#FFD700]/20 focus:ring-[#FFD700]",
    secondary: "bg-cyan-500/10 text-cyan-300 hover:bg-cyan-500/20 focus:ring-cyan-500"
  };

  return (
    <button 
      className={`${baseStyles} ${variants[variant]} ${className}`}
      aria-label={ariaLabel}
      {...props}
    >
      <span className="relative z-10 flex items-center justify-center">
        {children}
      </span>
    </button>
  );
}